import { createGlobalStyle, css } from 'styled-components';

const Typography = createGlobalStyle`${css`
	#smooth-content {
		will-change: transform;
	}

	/* //! For Calendar styles */
	.flatpickr-calendar {
		input:not(input[type='radio']) {
			padding: 0 0 0 0.5ch !important;
		}

		.flatpickr-day.selected {
			background-color: var(--black1000);
			border-color: var(--black1000);
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				.flatpickr-current-month {
					.numInputWrapper,
					.flatpickr-monthDropdown-months {
						&:hover {
							background-color: unset !important;
						}
					}
				}

				.flatpickr-prev-month,
				.flatpickr-next-month {
					&:hover {
						svg {
							fill: var(--black1000);
						}
					}
				}
			}
		}
	}

	html {
		/* //! Hide scrollbar */
		-ms-overflow-style: none;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		&.hidden {
			overflow: hidden !important;
			max-height: 100dvh !important;
		}
	}

	body {
		position: relative;
		width: 100%;
		min-height: 100vh;
		overflow-x: hidden;
		/* ${(props) => (props.$popupIsOpen || props.$isBurgerMenuOpen ? 'overflow-y: hidden' : '')}; */
		${(props) => (props.$popupIsOpen ? 'overflow-y: hidden' : '')};

		font-family: var(--neue);
		font-weight: 400;
		line-height: var(--lineHeightL);
		color: var(--black1000);

		${(props) => (props.$isPreloaderActive ? 'background-color: var(--black1000);' : 'background-color: var(--white1000);')};

		main {
			position: relative;
			display: flex;
			flex-direction: column;
			min-height: 100vh;
			padding-top: ${(props) => (props.$showPreloader ? '0' : 'var(--headerFixedHeight)')};
			will-change: transform;
			transition: var(--globalTransformVariables);
			z-index: 1;

			${(props) => (props.$isBurgerMenuOpen ? `transform: translateY(calc(${props.$burgerHeight}px - var(--headerFixedHeight) + var(--openedBurgerMenuAndMainContentDistance)))` : '')};
		}

		&.hidden-wrapper {
			overflow: hidden !important;
			max-height: 100dvh !important;
		}

		/* //! For IOS */
		&.touch-action {
			* {
				touch-action: none;
				-ms-touch-action: none;
			}
		}
	}

	//! Font sizes
	.h1-large,
	.cta-section-text {
		font-size: var(--h1Large);
		line-height: var(--lineHeightM);
	}

	.h1,
	h1 {
		font-size: var(--h1);
		line-height: var(--lineHeightM);
	}

	.h2,
	h2 {
		font-size: var(--h2);
		line-height: var(--lineHeightM);
	}

	.h3,
	h3 {
		font-size: var(--h3);
		line-height: var(--lineHeightM);
	}

	.h4,
	h4 {
		font-size: var(--h4);
		line-height: var(--lineHeightM);
	}

	.h5,
	h5 {
		font-size: var(--h5);
		line-height: var(--lineHeightM);
	}

	.h6,
	.faq,
	h6 {
		font-size: var(--h6);
		line-height: var(--lineHeightL);
	}

	.p,
	p {
		font-size: var(--p);
		line-height: var(--lineHeightL);

		--p: var(--p1);

		&.p1,
		&.about-us {
			--p: var(--p1);
		}

		&.p2,
		&.footer-li {
			--p: var(--p2);
		}

		&.p3,
		&.input,
		&.dropdown {
			--p: var(--p3);
		}

		&.p4 {
			--p: var(--p4);
		}

		&.p5,
		&.header {
			--p: var(--p5);
		}

		&.p6,
		&.faq-numbers {
			--p: var(--p6);
		}
	}
`}`;

export default Typography;
